import React from 'react'
import { APP_NAME } from 'configs/AppConfig';
import store from '../../redux/store/index'
import { setPyroVisible } from '../../redux/actions/Session';

export default function Footer() {
	let pyroCounter = 0;
	
	const showPyro = () => {
		pyroCounter ++;
		if(pyroCounter === 4)
		{
			pyroCounter = 0;
			store.dispatch(setPyroVisible(true))
			setTimeout(() => {
				store.dispatch(setPyroVisible(false))
			}, 5000)
		}
	}

	return (
		<footer
		id="footer"
		onClick={showPyro}
		className="footer">
			<span>Copyright  &copy;  {`${new Date().getFullYear()}`} <span className="font-weight-semibold">{`${APP_NAME}`}</span> All rights reserved.</span>
		</footer>
	)
}

